import React, { Component } from "react";
import { Box, Typography } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { motion } from "framer-motion";
import Utils from "../../../provider/Utils";
class HorizontalBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mercuryHeight: "0%", // Start at zero
    };
  }

  componentDidMount() {
    // Animate the mercury level after the component mounts
    const { goal, raised } = this.props;
    const percentage = Math.min((raised / goal) * 100, 100);

    setTimeout(() => {
      this.setState({ mercuryHeight: `${percentage}%` });
    }, 500);
  }
  componentDidUpdate(prevProps) {
    const { goal, raised } = this.props;
    if (prevProps.goal !== goal || prevProps.raised !== raised) {
      const percentage = Math.min((raised / goal) * 100, 100);
      this.setState({ mercuryHeight: `${percentage}%` });
    }
  }

  render() {
    const {
      goal,
      raised,
      color,
      pageId,
      isShowGoalAmount,
      measureType,
      is3dEffect,
      backgroundImage,
      meterFontColor,
    } = this.props;
    // Calculate percentage progress
    const percentage = Math.min((raised / goal) * 100, 100);
    // const mercuryHeight = this.state;
    return (
      <>
        <Box
          sx={{
            display: "flex",
          }}
        >
          <Box
            sx={{
              width: "35px",
              height: "60px",
              marginTop: pageId === "Pledge" ? "0px" : "54px",
              borderRadius: "60px 0px 0px 60px",
              position: "relative",
              overflow: "hidden",
              background: color,
              border: "10px solid lightgray",
              borderRight: "none",
              boxShadow: is3dEffect
                ? "inset 0px 10px 8px -6px rgba(0, 0, 0, 0.4), inset 0px -8px 8px -6px rgba(0, 0, 0, 0.4)"
                : "none",
            }}
          ></Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              // gap: 1,
              width: pageId === "Pledge" ? "100%" : "320px",
            }}
          >
            {pageId !== "Pledge" && (
              <motion.div
                animate={{ left: `${percentage}%` }}
                // animate={{ left: this.state.mercuryHeight }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                style={{
                  position: pageId === "Pledge" ? "relative" : "relative",
                  top: pageId === "Pledge" ? "15px" : "8px",
                  transform: "translateX(-50%)",
                  zIndex: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  color: "black",
                }}
              >
                <Box display="flex" alignItems="center">
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "0.875rem",
                      color:
                        backgroundImage !== null ? meterFontColor : "#353538",
                    }}
                  >
                    Raised:
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "21px",
                      color:
                        backgroundImage !== null ? meterFontColor : "#353538",
                      ml: 1,
                    }}
                  >
                    ${raised !== undefined ? raised.toLocaleString() : "0"}
                  </Typography>
                </Box>
                <ArrowDropDownIcon
                  sx={{
                    fontSize: 24,
                    color:
                      backgroundImage !== null ? meterFontColor : "#353538",
                  }}
                />
              </motion.div>
            )}
            {/* Thermometer Bar */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                // gap: 2,
                position: "relative",
                width: pageId === "Pledge" ? "100%" : "320px",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: "60px",
                  background: "#ddd",
                  // borderRadius: "50px",
                  position: "relative",
                  overflow: "hidden",
                  border: "10px solid lightgray",
                  borderLeft: "none",
                  borderRight: "none",
                  boxShadow: is3dEffect
                    ? `
      inset 0px 10px 8px -6px rgba(0,0,0,0.4),
      inset 0px -8px 8px -6px rgba(0,0,0,0.4)
    `
                    : "none",
                }}
              >
                {/* Temperature Fill */}
                <motion.div
                  initial={{ width: "0%" }} // starts at 0%
                  animate={{ width: `${percentage}%` }}
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                  style={{
                    height: "100%",
                    background: color,
                    // borderRadius: percentage < 100 ? "15px 0 0 15px" : "15px",
                    position: "relative",
                    boxShadow: is3dEffect
                      ? "inset 0px 10px 8px -6px rgba(0,0,0,0.4),inset 0px -8px 8px -6px rgba(0,0,0,0.4)"
                      : "none",
                  }}
                ></motion.div>

                {isShowGoalAmount &&
                  [...Array(26)].map((_, index) => (
                    <Box
                      key={index}
                      sx={{
                        position: "absolute",
                        left: `${(index / 26) * 100}%`,
                        bottom: "0",
                        width: index % 5 === 0 ? "1.5px" : "1px", // Bold for taller lines
                        height: index % 5 === 0 ? "12px" : "6px",
                        background: "#000",
                        opacity: index % 5 === 0 ? 0.8 : 0.6, // Optional: darker for bold lines
                        fontSize: "12px",
                      }}
                    />
                  ))}
              </Box>
            </Box>

            {/* Bottom Scale Markers */}
            {isShowGoalAmount && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: pageId === "Pledge" ? "100%" : "100%",
                  mt: measureType?.type === "% Meter" ? "4px" : "6%",
                  fontSize: pageId === "Pledge" ? "11px" : "",
                  color: backgroundImage !== null ? meterFontColor : "#353538",
                  // marginLeft: "12%",
                }}
              >
                {measureType?.type === "% Meter" ? (
                  <>
                    {[0, 0.2, 0.4, 0.6, 0.8, 1].map((value, index) => {
                      const amount = goal * value;
                      return (
                        <Typography
                          key={index}
                          variant="body2"
                          sx={{
                            visibility: amount === 0 ? "hidden" : "visible",
                            fontSize: pageId === "Pledge" ? "11px" : "",
                          }}
                        >
                          {`${(value * 100).toFixed(0)}%`}
                        </Typography>
                      );
                    })}
                  </>
                ) : (
                  <>
                    {[0, 0.2, 0.4, 0.6, 0.8, 1].map((value, index) => {
                      const amount = goal * value;
                      return (
                        <Typography
                          key={index}
                          variant="body2"
                          sx={{
                            visibility: amount === 0 ? "hidden" : "visible",
                            transform: "rotate(-30deg)",
                            transformOrigin: "left center",
                            display: "inline-block",
                            whiteSpace: "nowrap",
                            fontSize: pageId === "Pledge" ? "11px" : "",
                          }}
                        >
                          ${Utils.formatCompactNumber(amount)}
                        </Typography>
                      );
                    })}
                  </>
                )}
              </Box>
            )}
          </Box>
          <Box
            sx={{
              width: "35px",
              height: "60px",
              marginTop: pageId === "Pledge" ? "0px" : "54px",
              background: "#ddd",
              borderRadius: "0px 60px 60px 0px",
              position: "relative",
              overflow: "hidden",
              border: "10px solid lightgray",
              borderLeft: "none",
              boxShadow: is3dEffect
                ? `
      inset 0px 10px 8px -6px rgba(0,0,0,0.4),
      inset 0px -8px 8px -6px rgba(0,0,0,0.4)`
                : "none",
            }}
          ></Box>
        </Box>
      </>
    );
  }
}

export default HorizontalBar;
